import React, { useEffect, useState } from "react";
import { useLazyGenerateNestPayDataQuery } from "../../api/getShipmetBillPaymentLink/getShipmentBillLinkToPaySession";
import NestPayDataHandler from "./NestPayDataHandler";
import NestPayCard from "./NestPayCard";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { pushAlert } from "../alerts/alertSlice";
import GreenSpinner from "../../components/loaders/GreenSpinner";
import NestpaySelectCurrency from "./NestpaySelectCurrency";

const Nestpay = ({ billID, setPageToSelectPaymentSystem }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [
        generateNestpayData,
        { data: nestpayData, error: nestPayError, isLoading: nestPayIsLoading },
    ] = useLazyGenerateNestPayDataQuery();
    const [cardInfo, setCardInfo] = useState();

    const [currency, setCurrency] = useState("USD");

    const [fullTransactionData, setFullTransactionData] = useState(null);
    const [pressedPay, setPressedPay] = useState(false);

    const handlePayButtonClick = () => {
        if (!cardInfo) {
            dispatch(
                pushAlert({
                    message: t("bills.errors.fill_card_info"),
                    delay: 2000,
                    type: "danger",
                })
            );
            return;
        }

        setPressedPay(true);

        generateNestpayData({
            shipmentBillID: billID,
            currency,
        });
    };

    useEffect(() => {
        if (nestPayError) return;

        if (!pressedPay) return;

        if (!nestpayData || !nestpayData.ok || !nestpayData.data) return;

        if (!cardInfo) return;

        setFullTransactionData({
            ...nestpayData.data,
            ...cardInfo,
        });
    }, [nestpayData, nestPayError, pressedPay, cardInfo]);

    return (
        <div className="flex flex-col gap-1 m-auto px-5 pb-3">
            <NestPayDataHandler data={fullTransactionData} />
            <NestPayCard
                goBack={setPageToSelectPaymentSystem}
                setCardInfo={setCardInfo}
            />
            <div className="mb-4">
                <NestpaySelectCurrency currency={currency} setCurrency={setCurrency}/>
            </div>

            {nestPayIsLoading ? (
                <GreenSpinner width={30} />
            ) : (
                <Button
                    variant="contained"
                    sx={{
                        color: "white",
                        bgcolor: "#059669",
                        fontSize: "0.55rem",
                        padding: "0.25rem 1rem",
                        width: "100%",
                        ":hover": {
                            bgcolor: "#047857",
                        },
                    }}
                    onClick={handlePayButtonClick}
                >
                    {t("bills.bill_info.pay")}
                </Button>
            )}
            <Button
                variant="contained"
                sx={{
                    color: "white",
                    bgcolor: "#dc2626",
                    fontSize: "0.5rem",
                    padding: "0.25rem 1rem",
                    width: "fit-content",
                    ":hover": {
                        bgcolor: "#b91c1c",
                    },
                }}
                onClick={setPageToSelectPaymentSystem}
            >
                {t("bills.bill_info.go_back")}
            </Button>
        </div>
    );
};

export default Nestpay;
